// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `code[class*="language-"],
pre[class*="language-"] {
    text-align: left;
    white-space: pre-wrap;
    word-break: break-all;
    word-wrap: break-word;
    color: #c3cee3;
    background: #263238;
    font-family: Roboto Mono,"Liberation Mono",Menlo,Courier,monospace;
    font-size: 1em;
    line-height: 1.5;
    tab-size: 4;
    hyphens: none;
}

code[class*="language-"]::selection,
pre[class*="language-"]::selection,
code[class*="language-"] ::selection,
pre[class*="language-"] ::selection {
    background: #000000;
}

:not(pre) > code[class*="language-"] {
    white-space: normal;
    border-radius: 0.2em;
    padding: 0.1em;
}

pre[class*="language-"] {
    overflow: auto;
    position: relative;
    padding: 12px;
    border-radius: 4px;;
}

.language-css > code,
.language-sass > code,
.language-scss > code {
    color: #fd9170;
}

[class*="language-"] .namespace {
    opacity: 0.7;
}

.token.plain-text {
    color: #c3cee3;
}

.token.atrule {
    color: #c792ea;
}

.token.attr-name {
    color: #ffcb6b;
}

.token.attr-value {
    color: #c3e88d;
}

.token.attribute {
    color: #c3e88d;
}

.token.boolean {
    color: #c792ea;
}

.token.builtin {
    color: #ffcb6b;
}

.token.cdata {
    color: #80cbc4;
}

.token.char {
    color: #80cbc4;
}

.token.class {
    color: #ffcb6b;
}

.token.class-name {
    color: #82aaff;
}

.token.color {
    color: #f2ff00;
}

.token.comment {
    color: #546e7a;
}

.token.constant {
    color: #c792ea;
}

.token.deleted {
    color: #f07178;
}

.token.doctype {
    color: #546e7a;
}

.token.entity {
    color: #f07178;
}

.token.function {
    color: #c792ea;
}

.token.hexcode {
    color: #f2ff00;
}

.token.id {
    color: #c792ea;
    font-weight: bold;
}

.token.important {
    color: #c792ea;
    font-weight: bold;
}

.token.inserted {
    color: #80cbc4;
}

.token.keyword {
    color: #c792ea;
    font-style: italic;
}

.token.number {
    color: #fd9170;
}

.token.operator {
    color: #89ddff;
}

.token.prolog {
    color: #546e7a;
}

.token.property {
    color: #80cbc4;
}

.token.pseudo-class {
    color: #c3e88d;
}

.token.pseudo-element {
    color: #c3e88d;
}

.token.punctuation {
    color: #89ddff;
}

.token.regex {
    color: #f2ff00;
}

.token.selector {
    color: #f07178;
}

.token.string {
    color: #c3e88d;
}

.token.symbol {
    color: #c792ea;
}

.token.tag {
    color: #f07178;
}

.token.unit {
    color: #f07178;
}

.token.url {
    color: #fd9170;
}

.token.variable {
    color: #f07178;
}
`, "",{"version":3,"sources":["webpack://./src/styles/prism.css"],"names":[],"mappings":"AAAA;;IAEI,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,kEAAkE;IAClE,cAAc;IACd,gBAAgB;IAGhB,WAAW;IAIX,aAAa;AACjB;;AAUA;;;;IAII,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["code[class*=\"language-\"],\npre[class*=\"language-\"] {\n    text-align: left;\n    white-space: pre-wrap;\n    word-break: break-all;\n    word-wrap: break-word;\n    color: #c3cee3;\n    background: #263238;\n    font-family: Roboto Mono,\"Liberation Mono\",Menlo,Courier,monospace;\n    font-size: 1em;\n    line-height: 1.5;\n    -moz-tab-size: 4;\n    -o-tab-size: 4;\n    tab-size: 4;\n    -webkit-hyphens: none;\n    -moz-hyphens: none;\n    -ms-hyphens: none;\n    hyphens: none;\n}\n\n\ncode[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"]::-moz-selection,\ncode[class*=\"language-\"] ::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection {\n    background: #000000;\n}\n\ncode[class*=\"language-\"]::selection,\npre[class*=\"language-\"]::selection,\ncode[class*=\"language-\"] ::selection,\npre[class*=\"language-\"] ::selection {\n    background: #000000;\n}\n\n:not(pre) > code[class*=\"language-\"] {\n    white-space: normal;\n    border-radius: 0.2em;\n    padding: 0.1em;\n}\n\npre[class*=\"language-\"] {\n    overflow: auto;\n    position: relative;\n    padding: 12px;\n    border-radius: 4px;;\n}\n\n.language-css > code,\n.language-sass > code,\n.language-scss > code {\n    color: #fd9170;\n}\n\n[class*=\"language-\"] .namespace {\n    opacity: 0.7;\n}\n\n.token.plain-text {\n    color: #c3cee3;\n}\n\n.token.atrule {\n    color: #c792ea;\n}\n\n.token.attr-name {\n    color: #ffcb6b;\n}\n\n.token.attr-value {\n    color: #c3e88d;\n}\n\n.token.attribute {\n    color: #c3e88d;\n}\n\n.token.boolean {\n    color: #c792ea;\n}\n\n.token.builtin {\n    color: #ffcb6b;\n}\n\n.token.cdata {\n    color: #80cbc4;\n}\n\n.token.char {\n    color: #80cbc4;\n}\n\n.token.class {\n    color: #ffcb6b;\n}\n\n.token.class-name {\n    color: #82aaff;\n}\n\n.token.color {\n    color: #f2ff00;\n}\n\n.token.comment {\n    color: #546e7a;\n}\n\n.token.constant {\n    color: #c792ea;\n}\n\n.token.deleted {\n    color: #f07178;\n}\n\n.token.doctype {\n    color: #546e7a;\n}\n\n.token.entity {\n    color: #f07178;\n}\n\n.token.function {\n    color: #c792ea;\n}\n\n.token.hexcode {\n    color: #f2ff00;\n}\n\n.token.id {\n    color: #c792ea;\n    font-weight: bold;\n}\n\n.token.important {\n    color: #c792ea;\n    font-weight: bold;\n}\n\n.token.inserted {\n    color: #80cbc4;\n}\n\n.token.keyword {\n    color: #c792ea;\n    font-style: italic;\n}\n\n.token.number {\n    color: #fd9170;\n}\n\n.token.operator {\n    color: #89ddff;\n}\n\n.token.prolog {\n    color: #546e7a;\n}\n\n.token.property {\n    color: #80cbc4;\n}\n\n.token.pseudo-class {\n    color: #c3e88d;\n}\n\n.token.pseudo-element {\n    color: #c3e88d;\n}\n\n.token.punctuation {\n    color: #89ddff;\n}\n\n.token.regex {\n    color: #f2ff00;\n}\n\n.token.selector {\n    color: #f07178;\n}\n\n.token.string {\n    color: #c3e88d;\n}\n\n.token.symbol {\n    color: #c792ea;\n}\n\n.token.tag {\n    color: #f07178;\n}\n\n.token.unit {\n    color: #f07178;\n}\n\n.token.url {\n    color: #fd9170;\n}\n\n.token.variable {\n    color: #f07178;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
